<template>
  <h3 v-if="title != ''" @click="$router.back()"><i class="el-icon-arrow-left" v-if="type == ''"></i>{{title}}</h3>
  <h3 v-else class="">欢迎回来～</h3>
</template>
  
<script>
export default {
  name: 'SubTitleComponent',
  props: {
    title: '',
    type: ''
  },
  methods: {
    load () {
      // 
    }
  }
}
</script>
  
<style scoped lang="less">
.main {
  h3 {
    // display: inline-block;
    margin-bottom: 20px;
    padding-left: 8px;
    background: #fff;
    color: rgba(101,103,104,1);
    font-size: 18px;
    font-weight: 400;
    line-height: 32px;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SubTitleComponent.vue